<!--选择 年级-班级-->
<template>
  <el-cascader
    v-model="ids"
    size="small"
    :options="classOptions"
    collapse-tags
    class="select-student w-100"
    :show-all-levels="false"
    placeholder="选择班级"
    :props="{multiple: multiple}"
    @change="onChange"
  />
</template>
<script>
import fetch from '@/utils/fetch'

export default {
  model: {
    event: 'change'
  },
  props: {
    api: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      ids: [],
      classOptions: []
    }
  },
  watch: {
    value: {
      handler: function(newVal, oldVal) {
        this.ids = newVal
      },
      immediate: true
    }
  },
  created() {
    this.getStudents()
  },
  methods: {
    getStudents() {
      return fetch({
        url: this.api,
        method: 'post',
        data: {}
      }).then(res => {
        let parents = res.data.array || []
        // 遍历班级
        this.classOptions = parents.map((parent) => {
          const childs = parent.classrooms
          // 遍历年龄段
          let children = []
          if (this.$isArray(childs)) {
            children = childs.map((child) => {
              // 返回年龄段
              return {
                value: child.id,
                label: child.name
              }
            })
          }
          // 返回新的班级选项
          return {
            value: parent.code,
            label: parent.name,
            children
          }
        })
      }).catch(() => {
        // this.loading = false
      })
    },
    onChange(val) {
      console.log(val)
      this.$emit('change', val)
    }
  }
}
</script>
<style lang="scss" scoped type="text/scss">
  .nothingBox{
    text-align: center;
    padding: 100px 0;
    img{
      margin: 50px auto 0 auto;
      width: 240px;
    }
    p{
      text-align: center;
      font-size: 14px;
      color: #999;
      line-height: 30px;
    }
  }
</style>
